import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import ConfigurationForm from '../../components/ConfigurationForm/ConfigurationForm';
import { ExtendedRuleDefinition, RetailerOptConfig, Rule } from '../../gen/api/api';
import ApiService from '../../services/ApiService';
import { Typography, Backdrop, CircularProgress, Button, Tooltip } from '@material-ui/core';
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded';

export default function ConfigurationDetail() {
  const [ruleDefinitions, setRuleDefinitions] = useState<ExtendedRuleDefinition[]>();
  const [rules, setRules] = useState<Rule[]>();
  const [configRulesInitialized, setConfigRulesInitialized] = useState(false);
  const [dirty, setDirty] = useState(false);

  const { configurationId } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      if (configurationId) {
        const configuration: RetailerOptConfig = (await ApiService().fetchConfigurationById(configurationId)).data;
        setRules(configuration.rules);
      } else {
        setRules([]);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const ruleDefinitions: ExtendedRuleDefinition[] = (await ApiService().fetchRuleDefinitions()).data;
      setRuleDefinitions(ruleDefinitions);
    };
    fetchData();
  }, []);

  const isLoadingRules = configurationId && rules == undefined;
  const isLoadingRuleDefinitions = ruleDefinitions == undefined;
  const isLoadingConfigurationRules = configurationId != undefined && !configRulesInitialized;

  return (
    <div>
      <div style={{ display: 'inline-block', width: '100%' }} >
        <Typography style={{ float: 'left', marginLeft: '24px' }} variant="h6">
          <p />
          {configurationId != undefined ? "Edit Configuration" : "New Configuration"}
        </Typography>
        <Link
          to={'/'}
          style={{ textDecoration: 'none' }}
        >
          {/* Using zIndex to display Button on top of Backdrop */}
          <Tooltip title="Return to List of Configurations without saving changes" arrow>
            <Button style={{ float: 'right', margin: '18px', zIndex: 1 }}
              variant="contained"
              startIcon={<ArrowBackIosRoundedIcon />}
              onClick={(e) => {
                if (dirty && !isLoadingRules && !isLoadingRuleDefinitions && !isLoadingConfigurationRules
                  && !window.confirm("You will lose all unsaved changes. Are you sure you want to leave?")) {
                  e.preventDefault();
                }
              }}
            >
              Cancel & Return to List
            </Button>
          </Tooltip>
        </Link>
      </div>
      {rules && ruleDefinitions && <ConfigurationForm
        ruleDefinitions={ruleDefinitions}
        rules={rules}
        onRulesInitialized={() => setConfigRulesInitialized(true)}
        setDirty={setDirty}
      />}
      <Backdrop
        style={{ zIndex: 0, color: '#fff' }}
        open={isLoadingRules || isLoadingRuleDefinitions || isLoadingConfigurationRules}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div >
  );
}
